async function checkPincode(pincode) {
  try {
    // Load your JSON file from Shopify Files
    let response = await fetch("https://cdn.shopify.com/s/files/1/0916/9145/0670/files/csvjson.json?v=1756193394");
    let pincodes = await response.json();

    if (pincodes[pincode]) {
      return { 
        serviceable: true, 
        estimate: pincodes[pincode].estimate 
      };
    } else {
      return { serviceable: false };
    }
  } catch (err) {
    console.error("Error loading pincodes:", err);
    return { serviceable: false };
  }
}

document.addEventListener("DOMContentLoaded", function () {
  const input = document.querySelector("#checkout_postal_code"); // checkout pincode box
  if (!input) return;

  input.addEventListener("blur", async function () {
    let pin = input.value.trim();
    if (pin) {
      let result = await checkPincode(pin);
      let msgBox = document.querySelector("#pincode-message");
      if (!msgBox) {
        msgBox = document.createElement("div");
        msgBox.id = "pincode-message";
        input.parentNode.appendChild(msgBox);
      }

      if (result.serviceable) {
        msgBox.innerHTML = "✅ Delivery available. Estimated time: " + result.estimate;
        msgBox.style.color = "green";
      } else {
        msgBox.innerHTML = "❌ Sorry, we do not deliver to this pincode.";
        msgBox.style.color = "red";
      }
    }
  });
});